import React, { useState } from 'react'
import CustomSlider from 'components/Slider'
import useConfig from 'store/ConfigProvider'

import categoryUrl from 'helpers/categoryUrl'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { MobileCategoriesContent } from 'components/Widgets/Categories/Categories'

const SingleSlideContainer = styled.div`
  border-radius: 50%;
  background-color: #f2f4f5;

  & a {
    padding: 13px;
  }
`

const MobileCategorySlider = props => {
  const { topCategories, categories } = useConfig()
  const [isMenuOpen, setMenuOpen] = useState(false)

  const categoryIcons = {
    'eleqtro-teqnika': 'fas fa-laptop text-base text-sky-500',
    'mobiluri-telefonebi': 'fas fa-mobile-alt text-base text-[#FF6B42]',
    xelsacyoebi: 'fas fa-tools text-base text-[#FF8A3D]',
    'soflis-meurneoba': 'fas fa-seedling text-base text-[#4FC08D]',
    'citrus-shop': 'fas fa-store text-base text-[#FF3E78]',
    'autleti-da-bolo-erteuli': 'fas fa-tag text-base text-[#ff2337]',
  }

  return (
    <>
      <div className="flex items-end -mt-7 gap-2 p-[10px]">
        <button
          onClick={() => setMenuOpen(!isMenuOpen)}
          className="bg-[linear-gradient(to_right_top,#ff4b2b,#ff453e,#ff424e,#ff405d,#ff416c)] text-white p-[12px] rounded-full cursor-pointer flex items-center justify-center w-10 h-10 mb-[2px] transition-all duration-300 hover:shadow-[0_6px_20px_rgba(255,75,43,0.4)] relative"
        >
          <i
            className={`fas fa-bars w-4 h-4 text-center transition-all duration-300 ease-in-out ${
              isMenuOpen
                ? 'opacity-0 transform rotate-90 scale-50'
                : 'opacity-100 transform rotate-0 scale-100'
            }`}
          ></i>
          <i
            className={`fas fa-times w-4 h-4 text-center absolute transition-all duration-300 ease-in-out ${
              isMenuOpen
                ? 'opacity-100 transform rotate-0 scale-100'
                : 'opacity-0 transform -rotate-90 scale-50'
            }`}
          ></i>
        </button>
        <div className={'brands-slider'}>
          <CustomSlider
            style={{
              display: 'flex !important',
              justifyContent: 'space-between',
            }}
            settings={{
              dots: false,
              swipeToSlide: true,
              slidesToShow: 5,
              autoplay: true,
              autoplaySpeed: 1500,
            }}
          >
            {topCategories.map(cat => {
              const isCitrusShop = cat.title === 'Citrus Shop'
              const linkClasses = `relative flex items-center justify-center w-11 h-11 sm:w-24 bg-[#f7fafc] rounded-full cursor-pointer hover:bg-[#edf2f7] transition-all duration-300 ${
                isCitrusShop
                  ? "after:content-['NEW'] after:absolute after:top-0 after:right-[-9px] after:bg-[#ff2337] after:text-white after:text-[8px] after:px-[5px] after:pt-[3px] after:pb-[2px] after:rounded-md after:font-semibold"
                  : ''
              }`

              return (
                <div key={cat.url} className="px-1 sm w-">
                  <Link to={categoryUrl(cat.url)} className={linkClasses}>
                    <i className={`${categoryIcons[cat.url]}`}></i>
                  </Link>
                </div>
              )
            })}
          </CustomSlider>
        </div>
      </div>
      {isMenuOpen && (
        <MobileCategoriesContent
          open={isMenuOpen}
          setOpen={setMenuOpen}
          categories={categories}
          mobileTop={true}
        />
      )}
    </>
  )
}

export default MobileCategorySlider
